import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { LabState, LabStore } from './lab-store';
import { LabCasesState } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class LabQuery extends Query<LabState> {
	
	constructor(protected store: LabStore) {
		super(store);
	}
		
	get selectedCasesState(): LabCasesState {
		return this.getValue().selectedCasesState;
	}
}